export const demographic_labels = {
  ethnicity: {
    A: "Asian",
    B: "Black",
    L: "Latino",
    N: "Native American",
    W: "White",
    O: "Other",
  },
  parent: {
    Y: "Yes",
    N: "No",
    O: "Decline",
  },
  sex: {
    F: "Female",
    M: "Male",
    O: "Non-Binary",
    N: "Decline",
  },
  age: {
    "0-18": "0-18",
    "18-24": "18-24",
    "25-34": "25-34",
    "35-44": "35-44",
    "45-54": "45-54",
    "55-125": "55+",
  },
  income: {
    25: "<$25k",
    35: "$25k - $50k",
    50: "$25k - $50k",
    75: "$50k - $75k",
    100: "$75k - $100k",
    150: "$100k - $150k",
    200: "$150k - $200k",
    "200+": "$200k+",
  },
};

export const demographic_labels_compare = {
  ethnicity: demographic_labels.ethnicity,
  parent: demographic_labels.parent,
  sex: demographic_labels.sex,
  agegroup: demographic_labels.age,
  income: demographic_labels.income,
};
